module.exports = __webpack_public_path__ + "img/1.ff9d0f66.png";